module.exports = __webpack_public_path__ + "img/md.d4e707da.svg";